import LegalPage, { ToFill } from "@/components/LegalPage";

export default function Confidentialite() {
  return (
    <LegalPage title="Politique de confidentialité" updatedAt="2026-02-15" testid="page-privacy">
      <h2>Responsable de traitement</h2>
      <p>
        Le responsable de traitement est <strong>VALQORY</strong> (entrepreneur individuel — micro-entreprise),
        SIREN 109 877 399, joignable à l'adresse <a href="mailto:damienallais3@gmail.com">damienallais3@gmail.com</a>.
      </p>
      <p>
        RevenueFix AI étant un service destiné exclusivement aux professionnels, les traitements
        portent principalement sur des données professionnelles. Le RGPD s'applique aux données
        à caractère personnel éventuellement collectées (identifiant de la personne physique
        souscrivant au nom de l'entreprise, coordonnées).
      </p>

      <h2>Données collectées</h2>
      <ul>
        <li>Compte : email, nom, photo de profil (via Google), forfait souscrit.</li>
        <li>Utilisation : URL des sites audités, résultats d'audits, historique de scores.</li>
        <li>Paiements : identifiants Stripe (client, abonnement), statut d'abonnement — les données de carte ne transitent jamais par nos serveurs.</li>
        <li>Preuve d'acceptation B2B et des CGV : identifiant utilisateur, version des CGV, date/heure, adresse IP, user-agent, confirmation de qualité professionnelle.</li>
      </ul>

      <h2>Finalités</h2>
      <ul>
        <li>Fournir le service d'audit et d'export de rapports.</li>
        <li>Gérer l'abonnement, la facturation et le support.</li>
        <li>Respecter les obligations légales (comptabilité, conservation des preuves d'acceptation contractuelle).</li>
      </ul>

      <h2>Base légale</h2>
      <p>
        Exécution du contrat (fourniture du Service et facturation), respect d'obligations légales,
        et intérêt légitime pour la sécurité et l'amélioration du Service.
      </p>

      <h2>Destinataires et sous-traitants</h2>
      <ul>
        <li>Stripe (paiement) — <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">stripe.com/privacy</a>.</li>
        <li>Google (authentification) — <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">policies.google.com/privacy</a>.</li>
        <li>Anthropic (moteur d'analyse IA) — voir <a href="https://www.anthropic.com/legal/privacy" target="_blank" rel="noopener noreferrer">politique Anthropic</a>.</li>
        <li>Emergent (hébergement / prestataire d'infrastructure) — Emergent Labs Inc., 2380 Via Espada, Pleasanton, CA 94566, États-Unis — <a href="mailto:support@emergent.sh">support@emergent.sh</a>.</li>
      </ul>

      <h2>Durées de conservation</h2>
      <p>
        Compte et audits : conservés tant que le compte est actif. Preuves d'acceptation des CGV et
        factures : conservées pour la durée requise par la loi (typiquement 10 ans en comptabilité).
      </p>

      <h2>Vos droits</h2>
      <p>
        Les personnes physiques concernées disposent des droits d'accès, de rectification,
        d'effacement, de limitation, d'opposition et de portabilité. Pour les exercer,
        contacter <a href="mailto:damienallais3@gmail.com">damienallais3@gmail.com</a>.
        Une réclamation peut également être adressée à la CNIL.
      </p>

      <h2>Cookies</h2>
      <p>
        RevenueFix AI utilise un cookie de session strictement nécessaire à l'authentification
        (<code>session_token</code>). Aucun cookie publicitaire n'est déposé.
      </p>
    </LegalPage>
  );
}
